define('SuiteDynamics.PLPColorSwatches.ItemCell.ColorOptions.View',
	[
		'Backbone',
		'underscore',
		'jQuery',
		'Utils',
		'itemcell_coloroptions.tpl'
	],
	function (
		Backbone,
		_,
		jQuery,
		Utils,
		itemcell_coloroptions_tpl
	)
{
	'use strict';

	return Backbone.View.extend({
		template: itemcell_coloroptions_tpl,

		events: {
			'click .itemcoloroptions-coloroption-btn': 'changeItemImage'
		},

		initialize: function(options) {
			this.container = options.container;
			this.model = options.model;
			this.itemCellView = options.itemCellView;
			this.plp = this.container.getComponent('PLP');
			this.environment = this.container.getComponent('Environment');

			this.configuration = this.environment.getConfig('plpColorSwatches');

			this.itemColorSwatches = this.getItemColorSwatches();
		},

		getItemColorSwatches: function() {
			var itemColorOptions = this.getItemColorOptions();
			if (!itemColorOptions.length) return [];

			var colorValues = this.getColorValues(itemColorOptions);
			var colorLabels = this.getColorLabels(colorValues);

			var colorSwatches = this.buildColorSwatches(colorLabels);

			var selectedSwatch = _.findWhere(colorSwatches, { isSelected: true });
			if (selectedSwatch) {
				this.model.set('selectedColorId', selectedSwatch.colorInternalid);
				this.itemCellView.selectedColor = selectedSwatch.color;
				this.itemCellView.selectedColorId = selectedSwatch.colorInternalid;
			} else if (colorSwatches.length > 0) {
				this.model.set('selectedColorId', colorSwatches[0].colorInternalid);
				this.itemCellView.selectedColor = colorSwatches[0].color;
				this.itemCellView.selectedColorId = colorSwatches[0].colorInternalid;
			} else {
				this.model.set('selectedColorId', null);
				this.itemCellView.selectedColor = null;
				this.itemCellView.selectedColorId = null;
			}

			return colorSwatches;
		},

		getItemColorOptions: function() {
			var itemOptions = this.model.get('itemoptions_detail') && this.model.get('itemoptions_detail').fields || [];
			var itemColorOptionIds = this.configuration.colorOptionIds.split(',');
			return _.filter(itemOptions, function(itemOption) {
				return itemOption.internalid && _.contains(itemColorOptionIds, itemOption.internalid);
			});
		},

		getColorValues: function(itemColorOptions) {
			var colorValues = [];

			_.each(itemColorOptions, function(itemColorOption) {
				_.each(itemColorOption.values, function(value) {
					if (!!value.internalid && value.isAvailable) {
						colorValues.push(value);
					}
				});
			});

			return colorValues;
		},

		getColorLabels: function(colorValues) {
			return _.map(colorValues, function(colorValue) {
				return {
					label: colorValue.label,
					internalid: colorValue.internalid
				};
			});
		},

		buildColorSwatches: function(colorLabels) {
			var itemImages = this.model.get('itemimages_detail');
			var colorSwatches = [];
			var self = this;

			_.each(colorLabels, function(colorData) {
				var colorLabel = colorData.label;
				var colorInternalid = colorData.internalid;

				if (itemImages[colorLabel]) {
					var imageUrls = itemImages[colorLabel].urls;
					self.addColorSwatches(colorSwatches, imageUrls, colorLabel, colorInternalid, self.model.getThumbnail());
				}
			});

			return colorSwatches;
		},

		addColorSwatches: function(colorSwatches, imageUrls, colorLabel, colorInternalid, currentImage) {
			var self = this;
			_.each(imageUrls, function(imageUrl) {
				if (imageUrl.url.indexOf(self.configuration.imagesSuffix) > imageUrl.url.indexOf(colorLabel)) {
					var colorSwatch = {
						altText: imageUrl.altimagetext,
						color: colorLabel,
						colorInternalid: colorInternalid,
						imageUrl: self.resizeImage(imageUrl.url, self.configuration.colorSwatchImageResizeId)
					};
					colorSwatch.isSelected = self.isFirstImage(currentImage, colorLabel);

					colorSwatches[colorSwatch.isSelected ? 'unshift' : 'push'](colorSwatch);
				}
			});
		},

		isFirstImage: function(currentImage, colorLabel) {
			if (currentImage) {
				var currentImageTokens = currentImage.url.split('/').pop().split('_');
				return _.contains(currentImageTokens, colorLabel);
			}
			return false;
		},

		changeItemImage: function(e) {
			e.preventDefault();

			var $currentTarget = jQuery(e.currentTarget);

			var colorSwatchImage = $currentTarget.find('img');
			var selectedColor = $currentTarget.data('color');
			var selectedColorId = $currentTarget.data('internalid');

			this.itemCellView.selectedColor = selectedColor;
			this.itemCellView.selectedColorId = selectedColorId;

			this.itemCellView.render();

			var colorSwatchImageUrl = this.resizeImage(
				colorSwatchImage.prop('src'),
				this.configuration.itemCellImageResizeId
			);
			var colorSwatchImageAlt = colorSwatchImage.prop('alt');

			var itemCell = this.itemCellView.$el;
			var itemCellImage = itemCell.find('[class*="facets-item-cell-"][class*="-image-wrapper"] img');

			itemCellImage.prop('src', colorSwatchImageUrl);
			itemCellImage.prop('alt', colorSwatchImageAlt);
		},


		resizeImage: function(url, size) {
			var imageSizes = this.environment.getSiteSetting('imagesizes');
			var resize = _.findWhere(imageSizes, { name: size });

			if (resize) {
				url = this.removeUrlParameters(url, ['resizeid', 'resizeh', 'resizew']);
				return url + (~url.indexOf('?') ? '&' : '?') + resize.urlsuffix;
			}

			return url;
		},

		removeUrlParameters: function(url, parameters) {
			var baseUrl = url.split('?')[0];
			var query = url.indexOf('?') !== -1 ? url.split('?')[1] : '';
			var parametersList = query ? query.split('&') : [];

			parametersList = _.filter(parametersList, function(param) {
				return !_.contains(parameters, param.split('=')[0]);
			});

			return baseUrl + (parametersList.length ? '?' + parametersList.join('&') : '');
		},

		getContext: function() {
			return {
				itemColorSwatches: this.itemColorSwatches,
				selectedColor: this.model.get('selectedColor')
			};
		}
	});
});
